import { render, staticRenderFns } from "./SdsTableSection15.vue?vue&type=template&id=febdb742&scoped=true"
import script from "./SdsTableSection15.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsTableSection15.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SdsTableSection15.vue?vue&type=style&index=0&id=febdb742&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febdb742",
  null
  
)

export default component.exports